import { Component, HostListener } from '@angular/core';
import { Homecomp1Component } from '../components/comp1/homecomp1.component';
import { Homecomp2Component } from '../components/comp2/homecomp2.component';
import { Homecomp3Component } from '../components/comp3/homecomp3.component';
import { Homecomp4Component } from '../components/comp4/homecomp4.component';
import { Homecomp5Component } from '../components/comp5/homecomp5.component';
import { Homecomp6Component } from '../components/comp6/homecomp6.component';
import { Homecomp7Component } from '../components/comp7/homecomp7.component';


@Component({
selector: 'app-home',
standalone: true,
imports: [Homecomp1Component, Homecomp2Component, Homecomp3Component],
templateUrl: './home.component.html',
styleUrls: ['./home.component.scss']
})
export class HomeComponent {

}